/**
 * @KotlinClass com.sucsoft.organization.basic.management.commons.entity.AuthoxRole
 */
export class AuthoxRole {
    /**
     * @NomosDefineDescription "创建日期时间戳"
     * @NomosDefineType {"family":"number"}
     * @NomosGenericElements []
     */
    createtimestamp?: number;
    /**
     * @NomosDefineDescription "角色描述"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    des?: string;
    /**
     * @NomosDefineDescription "角色名称"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    name?: string;
    /**
     * @NomosDefineDescription "角色标识"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    role!: string;
    /**
     * @NomosDefineDescription "角色类型(gov政府端/expert专家端/produce生产主体端)"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    type?: string;
    /**
     * @NomosDefineDescription "当前人员数量"
     * @NomosDefineType {"family":"number"}
     * @NomosGenericElements []
     */
    usersNum!: number;
}
